import { Markdown } from "./Markdown";

type LegalContentProps = {
  content: string;
  lastUpdate: string;
  title: string;
};

export const LegalContent = ({
  content,
  lastUpdate,
  title,
}: LegalContentProps) => (
  <section className="py-14 px-4 m-auto max-w-5xl lg:py-24">
    <h1 className="mb-2 text-3xl font-medium lg:max-w-3xl lg:text-6xl">
      {title}
    </h1>
    <p className="lg:text-lg">{lastUpdate}</p>

    <Markdown content={content} />
  </section>
);
